import { useTheme } from "@/hooks/use-theme";
import { useAuth } from "@/hooks/use-auth";
import { Link } from "react-router-dom";

interface NavbarProps {
  onLogin: () => void;
  onSignup: () => void;
}

const Navbar = ({ onLogin, onSignup }: NavbarProps) => {
  const { theme, toggleTheme } = useTheme();
  const { user, signOut } = useAuth();

  return (
    <nav className="sticky top-0 z-[200] flex h-14 items-center justify-between border-b border-lt-border bg-lt-bg/[0.96] px-7 transition-colors">
      <div className="font-serif text-[21px] font-semibold tracking-wide text-foreground">
        Loto<em className="text-primary italic">Terminal</em>
      </div>
      <div className="flex items-center gap-6">
        <Link to="/quem-somos" className="text-[13px] tracking-wide text-lt-cream3 no-underline hover:text-foreground transition-colors">
          Quem somos
        </Link>
        <Link to="/alerta" className="text-[13px] tracking-wide text-lt-cream3 no-underline hover:text-foreground transition-colors">
          Alerta
        </Link>
        <Link to="/termos" className="text-[13px] tracking-wide text-lt-cream3 no-underline hover:text-foreground transition-colors">
          Termos de uso
        </Link>
        <a href="#planos" className="text-[13px] tracking-wide text-lt-cream3 no-underline hover:text-foreground transition-colors">
          Planos
        </a>
        <button
          onClick={toggleTheme}
          className="rounded-md border border-lt-border bg-transparent px-2.5 py-1.5 text-base text-lt-cream3 transition-all hover:border-lt-cream3 hover:text-foreground"
          aria-label="Alternar tema"
        >
          {theme === "dark" ? "☀" : "🌙"}
        </button>
        {user ? (
          <>
            <span className="text-[13px] text-lt-cream2 truncate max-w-[140px]">
              {user.user_metadata?.full_name || user.email?.split("@")[0]}
            </span>
            <Link
              to="/app"
              className="rounded-md bg-primary px-5 py-2 font-sans text-[13px] font-medium text-primary-foreground transition-colors hover:opacity-90"
            >
              Entrar no site
            </Link>
            <button
              onClick={signOut}
              className="rounded-md border border-lt-border bg-transparent px-5 py-2 font-sans text-[13px] text-lt-cream2 transition-colors hover:border-lt-cream3"
            >
              Sair
            </button>
          </>
        ) : (
          <>
            <button
              onClick={onLogin}
              className="rounded-md border border-lt-border bg-transparent px-5 py-2 font-sans text-[13px] text-lt-cream2 transition-colors hover:border-lt-cream3"
            >
              Entrar
            </button>
            <button
              onClick={onSignup}
              className="rounded-md bg-primary px-5 py-2 font-sans text-[13px] font-medium text-primary-foreground transition-colors hover:opacity-90"
            >
              Começar grátis
            </button>
          </>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
